import { FC, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

import { NavigationPanel } from '@sphera-cloud/component-ui-reactjs';

import { useAppSelector } from 'src/hooks';
import { menuSelector } from 'src/store/slices/menus';
import { IAppContext } from 'src/AppContext';

type Props = {
  children: ReactNode;
  context: IAppContext;
};

const Navbar: FC<Props> = ({ children, context }) => {
  const navigate = useNavigate();
  const { menu } = useAppSelector(menuSelector);

  if (
    location.hostname !== 'localhost' && !context.AuthService?.isAuthenticated()
  )
    return <></>;

  return (
    <NavigationPanel
      initMenus={menu}
      getChildMenus={() => { }}
      reload={false}
      treeBased
      navigate={navigate}
    >
      <section className="dm-page-content">{children}</section>
    </NavigationPanel>
  );
};

export default Navbar;
